import { render } from "./InvoiceAddress.vue?vue&type=template&id=18f5cc36"
import script from "./InvoiceAddress.vue?vue&type=script&lang=js"
export * from "./InvoiceAddress.vue?vue&type=script&lang=js"

import "./InvoiceAddress.vue?vue&type=style&index=0&id=18f5cc36&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__